import React from 'react'

import Navbar from 'components/Navbar'
import SketchHomeButton from 'components/SketchHomeButton'

import { ReactComponent as CrossIcon } from '@sketch/icons/cross-20-svg'

interface EmptyHeaderProps {
  title?: string
  onClickClose?: () => void
  hideLogo?: boolean
}

const EmptyHeader = ({ onClickClose, title, hideLogo }: EmptyHeaderProps) => (
  <Navbar>
    <Navbar.Section flex={0}>
      {onClickClose && (
        <>
          <Navbar.Button icon={CrossIcon} onClick={onClickClose} />
          <Navbar.Divider />
        </>
      )}
      {!onClickClose && !hideLogo && (
        <>
          <SketchHomeButton />
          <Navbar.Divider />
        </>
      )}
    </Navbar.Section>
    {title && <Navbar.Title>{title}</Navbar.Title>}
  </Navbar>
)

export default EmptyHeader
